import { Controller } from "@hotwired/stimulus"

const OPEN_CLASS = "translate-x-0"
const CLOSED_CLASS = "-translate-x-full"

// Slides the HQ sidebar in below the desktop breakpoint.
export default class extends Controller {
  static targets = ["panel", "backdrop", "openButton"]

  open(event) {
    event.preventDefault()
    this.panelTarget.classList.remove(CLOSED_CLASS)
    this.panelTarget.classList.add(OPEN_CLASS)
    this.backdropTarget.classList.remove("hidden")
    this.openButtonTarget.setAttribute("aria-expanded", "true")
  }

  close(event) {
    if (event) event.preventDefault()

    this.panelTarget.classList.remove(OPEN_CLASS)
    this.panelTarget.classList.add(CLOSED_CLASS)
    this.backdropTarget.classList.add("hidden")

    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.setAttribute("aria-expanded", "false")
    }
  }
}
